/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/assessment/question',['require','jquery','core/templates','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  //var _ = require('underscore');
  var templates = require('core/templates');
  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var Question = Marionette.ItemView.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    template: templates['screens/assessment/question'],
    events: {
      'click .item': 'optionPressed'
    },
    disabled: false,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(options)
    {
      //console.log('Question::initialize');

      if (options.options.shuffleResponses)
        this.collection.reset(this.collection.shuffle(), { silent:true });
    },

    serializeData: function()
    {
      // special serialize function to combine both model and collection data into the template renderer

      var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);
      data.items = this.serializeCollection.apply(this, [this.collection]);

      return data;
    },

    optionPressed: function(e)
    {
      if (this.disabled)
        return;
      //console.log('ressed', e, $(e.currentTarget));
      var option = this.collection.at($(e.currentTarget).index());
      this.triggerMethod('option:pressed', option, $(e.currentTarget));

      return false;
    },

    disable: function()
    {
      this.disabled = true;
    },

    enable: function()
    {
      this.disabled = false;
    }

  /*****************************************************************************************************************///}

  });

  return Question;

});

